An opaque string cursor for retrieving the previous page of results.
